import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import script from './slices/scriptSlice'
import role from './slices/roleSlice'
import analytics from "./slices/analyticsSlice"
import liveStream from "./slices/livestreamSlice"

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        script,
        role,
        analytics,
        liveStream,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
